// extracted by mini-css-extract-plugin
export default {"link":"styles_link__hOeYy","tooltip-overlay":"styles_tooltip-overlay__0z-uh","tooltip-wrapper":"styles_tooltip-wrapper__zduX0","tooltip-content":"styles_tooltip-content__2tnOl"};